// extracted by mini-css-extract-plugin
export var withdrawButton = "SkrillWithdrawView-module--withdrawButton--974a0";